// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3SMtN","clinicsSelect":"TableHeading_clinicsSelect__2YMef"};